<div
  class="shell eye-color"
  id="shell"
  [class.overlay-opened]="isOverlayOpen"
  [style.padding-right.px]="this.isOverlayOpen ? (scrollWidth$ | async) : 0"
>
  @if (eyeService.enabled) {
    <app-eye-panel />
  }
  @if (isOverlayOpen && !eyeService.enabled) {
    <app-overlay>
      @switch (isOverlayOpen) {
        @case (Overlays.Menu) {
          <app-main-menu />
        }
        @case (Overlays.Search) {
          <app-main-search />
        }
      }
    </app-overlay>
  }
  <app-header />
  <div class="shell__main" id="shell-content">
    <router-outlet />
  </div>
  @defer (on viewport) {
    <app-footer />
  } @placeholder {
    <app-skeleton />
  }
</div>

<app-cart-widget />

<app-swal />

<app-swal-error />

<app-cookies-accept-popup />
